import { t } from 'i18next';

export const enum TaniumStatus {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  STOPPING = 'STOPPING',
  STOPPED = 'STOPPED',
}

/**
 * Helper method for the label to display in our UI.
 */
export const getStatusLabel = (status: TaniumStatus): string => {
  switch (status) {
    case TaniumStatus.QUEUED:
      return t('projectIntegrations.tanium.status.queued');
    case TaniumStatus.RUNNING:
      return t('projectIntegrations.tanium.status.running');
    case TaniumStatus.STOPPING:
      return t('projectIntegrations.tanium.status.stopping');
    case TaniumStatus.COMPLETED:
      return t('projectIntegrations.tanium.status.completed');
    case TaniumStatus.STOPPED:
      return t('projectIntegrations.tanium.status.stopped');
  }
};

export const getStatusColor = (status: TaniumStatus) => {
  switch (status) {
    case TaniumStatus.QUEUED:
    case TaniumStatus.RUNNING:
    case TaniumStatus.STOPPING:
      return 'blue';
    case TaniumStatus.COMPLETED:
      return 'green';
    case TaniumStatus.STOPPED:
      return 'red';
  }
};

export const PENDING_STATUSES = [TaniumStatus.QUEUED, TaniumStatus.STOPPING];

export const ACTIVE_STATUSES = [TaniumStatus.QUEUED, TaniumStatus.RUNNING, TaniumStatus.STOPPING];

export const NON_ACTIVE_STATUSES = [TaniumStatus.COMPLETED, TaniumStatus.STOPPED];

export const NO_COMPLETED_RETRIEVAL_STATUSES = [null, TaniumStatus.STOPPED];
